import { useAuthServiceApiV2 } from '~/composables/useAuthServiceApi';

export default function CustomRoles() {
  return {
    get: async (clientID) =>
      useAuthServiceApiV2(`/clients/${clientID}/roles`, {
        method: 'GET',
      }),

    import: async (clientID, data, template) =>
      useAuthServiceApiV2(`/clients/${clientID}/roles/template_import`, {
        method: 'POST',
        body: data,
        params: {
          template_source: template,
        },
      }),

    export: async (clientID, template) => {
      return useAuthServiceApiV2(`/clients/${clientID}/roles/template_export`, {
        method: 'POST',
        body: {},
        params: {
          template_source: template,
        },
      });
    },

    fetchImportStatus: async (clientID, jobID) =>
      useAuthServiceApiV2(`/clients/${clientID}/roles/import_status`, {
        method: 'GET',
        params: {
          job_id: jobID,
        },
      }),
  };
}
